import React from "react";
import ReactDOM from "react-dom";
import ProfitCalculator from "./containers/ProfitCalculator";
import { getElementsProperty } from "../helpers/getElementsProperty";

export const initProfitCalculators = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<ProfitCalculator symbol={property.symbol} />, element);
  });
};
